// extracted by mini-css-extract-plugin
module.exports = {"home":"home-module--home--2wMD0","backgroundImg":"home-module--background-img--2KXPu","root":"home-module--root--2stqD","homeText":"home-module--home-text--2J0wS"};